import SustainabilityCircularity from "pages/SustainabilityCircularity";

export default function SustainabilityCircularityPage() {
  return <SustainabilityCircularity />;
}
